import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { IAngularMyDpOptions } from '@nodro7/angular-mydatepicker';

import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { DateUtilsService } from '../../../common/date-utils.service';
import { DATEPICKER_CONFIG } from '../../../common/datepicker-config';
import { FixDateService } from '../../../common/fixDate.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { AppConfig } from '../../../models/config/app-config';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-reisedaten',
  templateUrl: './reisedaten.component.html',
  styleUrls: ['./reisedaten.component.scss']
})
export class ReisedatenComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {

  private dVisumReisezweckSub: Subscription;
  dVisumReisezweckListItems: ValueListItem[];

  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              @Inject(DATEPICKER_CONFIG) public datepickerOptions: IAngularMyDpOptions,
              fixDateService: FixDateService,
              dateUtils: DateUtilsService,
              assistantPopoverService: AssistantPopoverService,
              @Inject(APP_CONFIG) public appConfig: AppConfig,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      dVisumZweck: [null, validationService.getValidators('reisedaten.dvisumAufenthaltszweck')],
      dVisumZweckSonstiges: [null, validationService.getValidators('reisedaten.dvisumAufenthaltszweckSonstiges')],
      dVisumErwerbstaetigkeit: [null, validationService.getValidators('reisedaten.dvisumErwerbstaetigkeit')],
      angegebenerReisezweck: [null, validationService.getValidators('reisedaten.angegebenerReisezweck')],
      von: [null, validationService.getValidators('visumdaten.gueltigkeit.von', true)],
      bisUngefaehr: [null, validationService.getValidators('visumdaten.gueltigkeit.bisUngefaehr.value')],
      bisGenau: [null, validationService.getValidators('visumdaten.gueltigkeit.bisGenau.value', true)],
      keine12MonateAufenthalt: [null, validationService.getValidators('reisedaten.keine12MonateAufenthalt')]
    }));

    this.dateFixer = fixDateService.getConverter({ unknownReplacement: '00' });
    this.dateFormatter = dateUtils.getFormatter('yMd');
  }

  ngOnInit(): void {
    super.ngOnInit();


    this.dVisumReisezweckSub = this.valueListsService.getValueListItems('d_visum_aufenthaltszweck')
    .subscribe((listItems: ValueListItem[]) => {
      this.dVisumReisezweckListItems = listItems;
    });

    this.form.controls.keine12MonateAufenthalt.valueChanges.subscribe(value => {
      if (this.form.value.keine12MonateAufenthalt !== value) {
        this.enableOrDisableControls(value);
      }
    });
  }

  private enableOrDisableControls(keine12MonateAufenthalt: boolean) {
    this.enableOrDisableControlWithTimeout(!keine12MonateAufenthalt, this.form.controls.bisUngefaehr);
    this.enableOrDisableControlWithTimeout(keine12MonateAufenthalt, this.form.controls.bisGenau);
  }

  ngOnDestroy(): void {
    this.dVisumReisezweckSub.unsubscribe();
  }

  onValidatorUpdate() {
    super.onValidatorUpdate();
    this.enableOrDisableControls(this.form.value.keine12MonateAufenthalt);
  }

}
